import { render, staticRenderFns } from "./DomainOSHardwareTemplate.vue?vue&type=template&id=8488438a&"
import script from "./DomainOSHardwareTemplate.vue?vue&type=script&lang=js&"
export * from "./DomainOSHardwareTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports